var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 48,
    height: 48,
    fill: "#FF6378"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6207 12H29.3793C33.0358 12 36 14.9642 36 18.6207V29.3793C36 33.0358 33.0358 36 29.3793 36H18.6207C14.9642 36 12 33.0358 12 29.3793V18.6207C12 14.9642 14.9642 12 18.6207 12Z",
    stroke: "#FF6378",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 28.5C18 28.5 19.7647 25.5 24 25.5C28.2353 25.5 30 28.5 30 28.5",
    stroke: "#FF6378",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20.5C21 20.7761 20.7761 21 20.5 21C20.2239 21 20 20.7761 20 20.5C20 20.2239 20.2239 20 20.5 20C20.7761 20 21 20.2239 21 20.5Z",
    fill: "#FF6378",
    stroke: "#FF6378",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20.5C28 20.7761 27.7761 21 27.5 21C27.2239 21 27 20.7761 27 20.5C27 20.2239 27.2239 20 27.5 20C27.7761 20 28 20.2239 28 20.5Z",
    fill: "#FF6378",
    stroke: "#FF6378",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedFace);
export default __webpack_public_path__ + "static/media/red-face.932c5c67b9d4c30c3eb790414c509c37.svg";
export { ForwardRef as ReactComponent };